class insurable {
    constructor(
    id,
    name,
    description,
    code) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.code = code;
    this.codeDescription = name + ': ' +"(" + description + ")"

  }
  static fromJson({ asegurableId, nombre, descripcion, codigo }) {
    return new insurable(asegurableId, nombre, descripcion, codigo);
  }
}
export default insurable;
